import {
  TextureLoader,
  LoadingManager
} from 'three'
import { GLTFLoader } from './utils/GLTFLoader'
import bidello from '../bidello'

const RESOURCES = []

class Assets {
  constructor() {
    this.resources = {}
  }

  loadGltfFirst() {
    const orientation = window.orientation === 0 ? 'portrait' : 'landscape'

    this.manager = new LoadingManager()
    this.textureLoader = new TextureLoader(this.manager)

    this.gltfLoader = new GLTFLoader(this.manager)

    this.manager.onProgress = ( url, itemsLoaded, itemsTotal ) => {
      this.onProgress(url, itemsLoaded, itemsTotal)
    }

    this.manager.onLoad = () => {
      this.finish()
    }

    const firstObject = {
      name: 'rewild_home',
      url:`/app/themes/rewild-yourself/dist/models/rewild${orientation === 'portrait' ? '-mobile' : ''}.gltf`
    }

    this.gltfLoader.load(firstObject.url, gltf => {
      this.resources[firstObject.name] = gltf
    })
  }

  onProgress(url, itemsLoaded, itemsTotal) {
    bidello.trigger({ name: 'loadProgress' }, { progress: ((100 * itemsLoaded) / itemsTotal) })
  }

  finish() {
    bidello.trigger({ name: 'loadEnd' }, { resources: this.resources })
  }
}

export default new Assets()
